import React, { useEffect } from 'react';
import { toast } from "sonner";
import { TrendingUp, TrendingDown } from "lucide-react";

export function showAlertNotification(alert, onClick) {
    const isBuy = alert.signal === 'BUY';

    toast.custom((t) => (
        <div
            onClick={() => {
                if (onClick) onClick(alert);
                toast.dismiss(t);
            }}
            className={`
        max-w-md w-full rounded-xl shadow-2xl p-4 cursor-pointer transition-transform hover:scale-[1.02]
        ${isBuy
                    ? 'bg-gradient-to-r from-emerald-900 to-emerald-800 border border-emerald-500/30'
                    : 'bg-gradient-to-r from-red-900 to-red-800 border border-red-500/30'
                }
      `}
        >
            <div className="flex items-start gap-3">
                <div className={`
          w-10 h-10 rounded-lg flex items-center justify-center shrink-0
          ${isBuy ? 'bg-emerald-500/20' : 'bg-red-500/20'}
        `}>
                    {isBuy ? (
                        <TrendingUp className="w-5 h-5 text-emerald-400" />
                    ) : (
                        <TrendingDown className="w-5 h-5 text-red-400" />
                    )}
                </div>
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <span className={`
              font-bold text-sm px-2 py-0.5 rounded
              ${isBuy ? 'bg-emerald-500 text-white' : 'bg-red-500 text-white'}
            `}>
                            {alert.signal}
                        </span>
                        <span className="text-white font-medium">{alert.pair}</span>
                        <span className="text-slate-400 text-sm">{alert.timeframe}</span>
                    </div>
                    <p className="text-slate-300 text-sm truncate">
                        Entry: {alert.entry} | SL: {alert.sl}
                    </p>
                    {alert.indicator && (
                        <p className="text-slate-500 text-xs mt-1">
                            {alert.indicator}
                        </p>
                    )}
                </div>
            </div>
        </div>
    ), {
        duration: 4000,
        position: 'top-right',
    });
}

// Request browser notification permission
export function requestNotificationPermission() {
    if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission();
    }
}

// Show browser notification (optional)
export function showBrowserNotification(alert) {
    if ('Notification' in window && Notification.permission === 'granted') {
        const isBuy = alert.signal === 'BUY';
        new Notification(`${alert.signal} Signal - ${alert.pair}`, {
            body: `Entry: ${alert.entry} | SL: ${alert.sl}`,
            icon: isBuy ? '🟢' : '🔴',
            tag: alert.id,
        });
    }
}
